import { h, JSX } from 'preact';
import classNames from "classnames";
import {CloseIcon, SearchIcon} from './Icons';

export interface TextFieldProps {
    label?: string;
    id?: string;
    value: string;
    onChange?: (value: string) => void;
    placeholder?: string;
    inputClass?: string;
    required?: boolean;
    disabled?: boolean;
    inputmode?: string;
    error?: string;
    type?: 'text' | 'password' | 'email' | 'number' | 'search';
    searchIconPath?: string;
    onClear?: () => void;
    prefix?: string;
}

export const TextField = (props: TextFieldProps): JSX.Element => {
    const inputClass = classNames(
        'form-control block w-full h-12 py-3 transition duration-75 rounded-lg outline-none focus:border-primary-500',
        'focus:ring-1 focus:ring-inset focus:ring-primary-500 disabled:opacity-70 border-gray-300',
        {
            'pl-[48px]': props.type === 'search',
            'pr-[48px]': props.onClear
        },
        props.inputClass
    );

    return (
        <div class='mb-4 last:mb-0'>
            {props.label && (
                <label for={props.id} class='k-body-bold block font-semibold mb-2'>
                    {props.label}
                </label>
            )}
            <div class='textfield relative'>
                <input
                    type={props.type ?? 'text'}
                    class={inputClass}
                    id={props.id}
                    value={(props.prefix ? props.prefix + ' ' : '') + props.value}
                    onInput={(event): void => props.onChange?.(event.currentTarget.value.replace((props.prefix ? props.prefix + ' ' : ''), ''))}
                    placeholder={props.placeholder}
                    required={props.required}
                    disabled={props.disabled}
                    inputmode={props.inputmode}
                />
                {props.type === 'search' && (
                    <div class='absolute top-0 left-0 w-[48px]'>
                        <SearchIcon />
                    </div>
                )}
                {props.onClear && (
                    <button onClick={props.onClear} type='button' class='absolute right-[9px] top-[9px]'>
                        <CloseIcon/>
                    </button>
                )}
                {props.error && <div class='textfield__invalid text-kinola-orange'>{props.error}</div>}
            </div>
        </div>
    );
}
